import $ from 'jquery';

export function alterRepresentatives (form, estabelecimentoId) {
  const args = $(form).serialize() + "&estabelecimento_id=" + estabelecimentoId;

  Promise.resolve($.post("/admin/estabelecimento/representante", args))
    .then(resp => {
      if (resp.sucesso == "false") {
        throw new Error("Error inserting representatives")
      }

      return resp;
    })
    .then(() => sisSetAlert("true", "Representantes cadastrados"))
    .catch(() => sisSetAlert("false", "Error ao cadastrar representantes, tente novamente mais tarde"));
}


// WEBPACK FOOTER //
// ./resources/js/representante/form.js